import React,{Fragment} from "react"
import ListItem from '@material-ui/core/ListItem'
import { withStyles } from '@material-ui/core/styles'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import Icon from '@material-ui/core/Icon'
import { withTheme } from '@material-ui/core/styles'
import moment from 'moment'
import Grid from '@material-ui/core/Grid'
import { I18n } from 'react-redux-i18n'


const styles = theme => ({
  mainList:{
    width: '100%',
    color: '#009fe3',
    padding: '12px 0'
  },
  mainListIcon: {
    display: 'inline-block'
  },
  mainListText: {
    display: 'inline-block'
  },
  button: {
    margin: 0,
  },
  icon: {
    height: '1.4em',
    lineHeight: '1.4em',
    fontSize: '2em'
  },
  secondaryItem:{
    marginLeft: 10,
    display: 'inline-block',
  },
  primaryItem:{
    width: '90px',
    display: 'inline-block',
  }
});

class NoAppointment extends React.Component {

  render(){
    return(
      <Fragment>
        <ListItem>
          <MainList appointment={this.props.appointment} selectedDate={this.props.selectedDate.format('YYYYMMDD')} classes={this.props.classes} />
        </ListItem>
        <Divider />
      </Fragment>
    )
  }
}

function MainList(props){
  let timeItem = null
  let fromItem = null

    timeItem = <span className={props.classes.primaryItem}>{props.appointment.van_tijd + " - " + props.appointment.tot_tijd}</span>

    if(moment(props.selectedDate+props.appointment.fromTime, 'YYYYMMDDhhmm').diff(moment()) <= 0 && moment(props.selectedDate+props.appointment.toTime, 'YYYYMMDDhhmm').diff(moment()) >= 0){
      fromItem = <span className={props.classes.secondaryItem}>{I18n.t('appointments.now')}</span>
    }else if(moment(props.selectedDate+props.fromTime, 'YYYYMMDDhhmm').diff(moment()) < 0){
      fromItem = <span className={props.classes.secondaryItem}>{moment(props.selectedDate+props.appointment.tot_tijd, 'YYYYMMDDhhmm').fromNow()}</span>
    }else{
      fromItem = <span className={props.classes.secondaryItem}>{moment(props.selectedDate+props.appointment.van_tijd, 'YYYYMMDDhhmm').fromNow()}</span>
    }

  return(
    <div onClick={props.onClick} className={props.classes.mainList}>
      <Grid container justify="center" >
        <Grid item container xs={2} md={1}>
          <Icon className={props.classes.icon}>
              timelapse
          </Icon>
        </Grid>
        <Grid item container xs={10} md={11}>
          <ListItemText
            primary={
              <span>
                No appointment
              </span>
            }
            secondary={
              <span>
                {timeItem}
                {fromItem}
              </span>
            }
            className={props.classes.mainListText}
          />
        </Grid>
      </Grid>
    </div>
  )
}

export default withTheme()(withStyles(styles)(NoAppointment))



// WEBPACK FOOTER //
// ./src/js/components/pages/appointment/NoAppointment.js